import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

if (window.location.pathname === '/callback' && !window.location.hash.startsWith('#/callback')) {
  const search = window.location.search || '';
  window.location.replace(`${window.location.origin}/#/callback${search}`);
}

if (/^\/\d+\/?$/.test(window.location.pathname)) {
  window.location.replace(`${window.location.origin}/#/`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);